<app-public-header />
<div class="mt-4 d-flex flex-column align-items-center">
  <h2>Page not found</h2>
  <p class="lead">We couldn't find the page you were looking for.</p>
  <div>
    <button class="btn btn-green w-auto me-2" (click)="goBack()">Go back</button>
    <button class="btn btn-green w-auto" (click)="backHome()">Back to home</button>
  </div>
</div>
